import { Alert } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";
import TitleStripe from "../TitleStripe";

const MaisNegocioPJ = ({ data }) => {
  return (
    <>
      <TitleStripe>Mais Negócio</TitleStripe>
      {data?.ErrorMessage ? (
        <Alert className="mt-1" withBorderAccent>
          {data?.ErrorMessage}
        </Alert>
      ) : (
        <>
          {" "}
          <div className="flex items-center gap-2">
            <div className="font-semibold">Empresa:</div>
            <div className="capitalize">{data?.CompanyName?.toLowerCase()}</div>
          </div>
          <div className="flex gap-8">
            <div className="flex items-center gap-2">
              <div className="font-semibold">Porte da empresa:</div>
              <div>{data?.CompanySize}</div>
            </div>

            <div className="flex items-center gap-2">
              <div className="font-semibold">Capacidade de pagamento:</div>
              <div>{data?.PaymentCapability}</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-semibold">Perfil de risco:</div>
              <div className="capitalize">
                {data?.RiskExposure?.toLowerCase()}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 items-center gap-2">
            <div className="flex flex-col items-center gap-10 mt-4">
              <div>
                {data?.Recommendation?.includes("1") && (
                  <img className="w-20" src="/assets/semaforo_vermelho.jpg" />
                )}
                {data?.Recommendation?.includes("2") && (
                  <img className="w-20" src="/assets/semaforo_amarelo.jpg" />
                )}
                {data?.Recommendation?.includes("0") && (
                  <img className="w-20" src="/assets/semaforo_verde.jpg" />
                )}
              </div>
              <div
                className={`font-bold text-lg ${
                  data?.Recommendation?.includes("1")
                    ? "text-red-500"
                    : data?.Recommendation?.includes("2")
                    ? "text-yellow-600"
                    : "text-green-500"
                }`}
              >
                {data?.Recommendation}
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="underline font-semibold mt-4">Motivos:</div>
              {data?.RecommendationReason1 && (
                <div>{data?.RecommendationReason1}</div>
              )}
              {data?.RecommendationReason2 && (
                <div>{data?.RecommendationReason2}</div>
              )}
              {data?.RecommendationReason3 && (
                <div>{data?.RecommendationReason3}</div>
              )}
              {data?.RecommendationReason4 && (
                <div>{data?.RecommendationReason4}</div>
              )}
              {data?.RecommendationReason5 && (
                <div>{data?.RecommendationReason5}</div>
              )}
              {data?.RecommendationReason6 && (
                <div>{data?.RecommendationReason6}</div>
              )}
              {data?.RecommendationReason7 && (
                <div>{data?.RecommendationReason7}</div>
              )}
              {data?.RecommendationReason8 && (
                <div>{data?.RecommendationReason8}</div>
              )}
              {data?.RecommendationReason9 && (
                <div>{data?.RecommendationReason9}</div>
              )}
              {data?.RecommendationReason10 && (
                <div>{data?.RecommendationReason10}</div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MaisNegocioPJ;
